export const SET_HOURS_ENDORSEMENT_COUNT = 'SET_HOURS_ENDORSEMENT_COUNT'
export const SET_DISCREPANCIES_COUNT = 'SET_DISCREPANCIES_COUNT'
export const SET_HASNOTPRESENTREPORTS_VALUE = 'SET_HASNOTPRESENTREPORTS_VALUE'
export const SET_NOTIFICATIONS_VALUE = 'SET_NOTIFICATIONS_VALUE'
export const SET_SECTIONRELOAD_VALUE = 'SET_SECTIONRELOAD_VALUE'
export const SET_PYRO_VISIBLE = 'SET_PYRO_VISIBLE'